import { ADDRESS_TYPES } from '@/config/fulfillmentWizardSteps'

const zonePayload = zone => {
  if (zone.kind === 'map') return { kind: 'map', waypoints: zone.waypoints.map(([lat, lng]) => ({ lat, lng })) }
  if (zone.kind === 'zips') return { kind: 'zips', zip_codes: zone.zipCodes }
  if (zone.kind === 'states') return { kind: 'states', states: zone.states }
  return { kind: 'anywhere' }
}

export const buildSetupPayload = data => {
  const s = data.schedule
  const payload = {
    type: data.type,
    name: data.name.trim(),
    store_ids: data.storeIds.map(Number),
    schedule: {
      rhythm: s.rhythm,
      weekdays: s.rhythm === 'once' ? [] : s.weekdays.map(Number).sort((a, b) => a - b),
      date: s.rhythm === 'once' ? s.date : null,
      arrival: { start: s.arrival.start, end: s.arrival.end },
      production_days_before: s.productionDaysBefore,
      ordering: {
        closes: { days_before: s.closes.daysBefore, time: s.closes.time },
        opens: { kind: s.opens.kind, days: s.opens.kind === 'days_before' ? s.opens.days : null }
      },
      limit: s.limit
    },
    pricing: {
      price_cents: data.pricing.priceCents,
      taxable: data.pricing.taxable,
      minimum_order_cents: data.pricing.minimumOrderCents
    }
  }
  if (ADDRESS_TYPES.includes(data.type)) payload.address = { ...data.address }
  else payload.zone = zonePayload(data.zone)
  return payload
}
